import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import {connectForm} from '../../core/redux/form'
import {replace} from '../../core/extract'
import LoaderButton from '../../core/components/LoaderButton'
import {IDENTIFY_COMPANY_CMD_UPDATED, sendUpgradeCompanyToStandardAccountCmd, sendIdentifyCompanyCmd, loadCompany, loadCompanyStream} from '../actions'
import {IdentifyCompanyCmd} from '../models'
import i18n from '../i18n'
import style from './UpgradeDowngradeStandardAccountModal.less'

class UpgradeDowngradeStandardAccountModal extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    _sendUpgradeCmd() {
        const {dispatch, company, onHide} = this.props

        return Promise.resolve(company.billingType != 'StandardAccount' && !company.siretNumber && dispatch(sendIdentifyCompanyCmd())).then(() => {
            return dispatch(sendUpgradeCompanyToStandardAccountCmd())
        }).then(() => {
            return dispatch(loadCompany())
        }).then(() => {
            return dispatch(loadCompanyStream())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, company, onHide, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        return (
            <Modal
                className='modal-danger'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{company.billingType == 'StandardAccount' && i18n.downgrade || i18n.upgrade}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.defaultContent}>
                    <div className={style.text}>
                        {company.billingType != 'StandardAccount' && i18n.upgradeStandardAccountText.map((text, index) => (
                            <p key={index}>{replace(text, company)}</p>
                        ))}
                    </div>
                        {company.billingType != 'StandardAccount' && !company.siretNumber && (
                            <form>
                                <Input
                                    type='text'
                                    name='siret'
                                    placeholder={i18n.siret + ' *'}
                                    {...form.siretNumber()} />
                            </form>
                        )}
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='danger'
                            bsSize='large'
                            disabled={company.billingType != 'StandardAccount' && !company.siretNumber && !form.isValid()}
                            onClick={() => company.billingType != 'StandardAccount' && this._sendUpgradeCmd()}>
                            {company.billingType == 'StandardAccount' && i18n.downgrade || i18n.upgrade}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

UpgradeDowngradeStandardAccountModal = connectForm({
    target: 'cmd',
    schema: IdentifyCompanyCmd.schema,
    action: IDENTIFY_COMPANY_CMD_UPDATED
})(UpgradeDowngradeStandardAccountModal)

UpgradeDowngradeStandardAccountModal = connect((state) => ({
    cmd: state.company.identifyCompanyCmd,
    company: state.company.company
}))(UpgradeDowngradeStandardAccountModal)

export default UpgradeDowngradeStandardAccountModal


// WEBPACK FOOTER //
// ./lib/company/components/UpgradeDowngradeStandardAccountModal.js